import './form-field-error.css';

const FormFieldError = ({errorMessage}) => {
    return <>
        {
            errorMessage ? <label className="error-label">{errorMessage}</label> :''
        }
    </>
}
export default FormFieldError;